import { Component, input } from '@angular/core';
import { SpinnerService } from '../../services/spinner/spinner.service'; // eslint-disable-line

/**
 * Used in conjunction with `SpinnerService`
 * @see {@link SpinnerService}
 */
@Component({
    selector: 'r1-loading-spinner',
    template: `
        <div class="r1-loading-spinner-overlay">
            <div class="r1-loading-spinner"></div>
            @if (loadingMessages().length > 0) {
                <div class="r1-loading-message-container">
                    <span class="r1-loading-message">{{ loadingMessages()[0] }}</span>
                </div>
            }
        </div>
    `,
    styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
    loadingMessages = input.required<string[]>();
}
